const HTTP_ERRORS = {
  appointment_conflict:
    'Ops, as atualizações de atendimento não puderam ser salvas',
  authorization_exception:
    'Por favor, verifique se você possui as permissões necessárias para esta operação',
  conflict: 'Desculpe, houve um problema durante sua edição',
  database_not_found_item:
    'Desculpe, houve um erro ao recuperar as informações.',
  file_required: 'Ops, é possível completar a operação sem um arquivo anexo',
  health_community_specialist_not_found: 'Especialista não encontrado',
  health_community_specialist_without_specialty:
    'Especialista não vinculado a uma especialidade',
  health_declaration_not_started: 'Declaração de saúde não preenchida',
  illegal_argument: 'Os dados enviados não são válidos',
  invalid_file: 'O arquivo enviado não é válido',
  invalid_national_id: 'Número de CPF inválido',
  multipart_required: 'Erro de requisição',
  person_id_required: 'Ops, os dados da requisição estão incompletos',
  person_not_authorized:
    'Por favor, verifique se você possui as permissões necessárias para efetuar essa operação',
  prescription_sentence_failed_on_update:
    'Desculpe, houve um erro ao atualizar a sentença da prescrição',
  resource_not_found:
    'Desculpe, houve um erro ao recuperar os recursos solicitados',
  unauthorized_to_perform_action:
    'Ops, você não possui as permissões necessárias para efetuar esta ação',
  validation_error: 'Desculpe, não foi possível validar os dados informados',
  access_forbidden:
    'Ops, você não possui as permissões necessárias para efetuar essa operação'
}

const HTTP_MESSAGE_ERRORS = {
  is_not_empty_channel: 'Este canal já foi pego por outro profissional'
}

const INPUT_ERRORS = field => ({
  required: `É necessario preencher o campo ${field}`,
  invalid: `Por favor, insira um valor de ${field} válido`
})

const CONTEXT_ERRORS = {
  timeline_appointments_error: 'atendimentos',
  timeline_health_forms_error: 'questionários de saúde',
  timeline_counter_referral_error: 'contrarreferências',
  timeline_third_party_appointments_error: 'outros tipos de atendimentos',
  timeline_emergency_room_attendance_error: 'pronto socorro',
  timeline_hospitalization_attendance_error: 'hospitalizações',
  timeline_surgery_attendance_error: 'cirurgias',
  appointment: 'atendimento',
  timeline: 'timeline',
  cases: 'condição',
  profile: 'profile'
}

export { HTTP_ERRORS, INPUT_ERRORS, CONTEXT_ERRORS, HTTP_MESSAGE_ERRORS }
